import Bullet from '@components/Bullet';
import { styled } from '@linaria/react';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { themeDefault, useTheme } from 'src/theme-revamp';
import BottomSheetDrag from '../BottomSheetDrag';
import { Tooltip } from '../Tooltip/Tooltip';
import { TooltipBottomSheet } from '@components/_Revamp/TooltipBottomSheet/TooltipBottomSheet';


const ModalContainer = styled.div`
  position: fixed;
  display: block;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 100;
  overflow-x: hidden;
  background-color: rgba(51, 51, 51, 0.85);
  pointer-events: none;
  opacity: 0;
  transition: opacity 500ms ease;
  box-shadow: none;
  
  @media screen and (max-width: 768px) {
    display:none;
  }
`

const MobileModalContainer = styled.div`
  display: block;
  @media screen and (min-width: 768px) {
    display: none;
  }
`;

const BulletListingText = styled.p`
  color: #434343 !important;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.4;
  letter-spacing: 0.015;
  span {
    color: #883E89;
    text-decoration: underline;
    text-decoration-style: dotted;
    text-underline-offset: 2px;
    text-decoration-thickness: 3px;
    text-decoration-skip-ink: none;
    cursor: pointer;
  }
`;

// const Bullet = styled.span`
//   display: block;
//   width: 5px;
//   height: 5px;
//   border-radius: 100rem;
//   background-color: #434343;
// `;

const BulletListingItem = styled.li`
  display: flex;
  align-items: center;
  column-gap: 18px;
`;

const BulletLisingContainer = styled.ul<Omit<BulletListingProps, 'bulletList'>>`
  display: flex;
  flex-direction: column;
  row-gap: ${(props) => typeof props.rowGap === 'number' ? props.rowGap + 'px' : '26px'};
  padding: ${(props) => typeof props.padding === 'string'
    ? props.padding
    : typeof props.padding === 'number'
    ? props.padding + 'px'
    : '0'};
`;

export interface BulletItemModel {
  text: string;
  highlightText?: string[];
  tooltipContent?: JSX.Element;
}
export interface BulletListingProps {
  bulletList: BulletItemModel[];
  padding?: string | number;
  rowGap?: number;
}

export type BulletItemProps = BulletItemModel & {
  onHighlightHover: (tooltipContent: any, e:any, type:string) => void;
  onHighlightUnHover: (e:any) => void;
  onHighlightClick?: (tooltipContent: any, e:any, type:string) => void;
}

export const BulletItem = ({ text, highlightText, tooltipContent, onHighlightHover, onHighlightUnHover,onHighlightClick }: BulletItemProps) => {
  const [bulletContent, setBulletContent] = useState<any>(text)

  // const Highlight_Hover = (e: any)=>{
  //   onHighlightHover(tooltipContent, e)
  // }

  const HandleHighlight_Hover = useCallback(
    (e: any) => {
      onHighlightHover(tooltipContent, e, "")
    },
    [onHighlightHover, tooltipContent],
  )

  const HandleHighligh_UnHover = useCallback(
    (e: any) => {
      onHighlightUnHover(e);
    },
    [onHighlightUnHover],
  )

  const HandleHighlight_Click = useCallback(
    (e: any) => {
      if (onHighlightClick) {
        onHighlightClick(tooltipContent, e, "click");
      }
    },
    [onHighlightClick,tooltipContent],
  )



  useEffect(() => {
    // if(highlightText){
    //   const firstHighlightTextIndex = text.indexOf(highlightText);
    //   const lastHighlightTextIndex = firstHighlightTextIndex + highlightText?.length;
    //   const contentWithHighlight = [`${text.substring(0,firstHighlightTextIndex)}`, <span onMouseOver={HandleHighlight_Hover} onMouseLeave={HandleHighligh_UnHover}>{highlightText}</span>, text.substring(lastHighlightTextIndex, text.length)]
    //   setBulletContent(contentWithHighlight);
    // }

    let contentWithHighlight: any[] = [];
    if (highlightText) {
      for(let i=0; i<highlightText.length; i++){
        const firstHighlightTextIndex = text.indexOf(highlightText[i]);
        if(i === 0) contentWithHighlight.push(text.substring(0, firstHighlightTextIndex));
        contentWithHighlight.push(<span onMouseOver={HandleHighlight_Hover} onMouseLeave={HandleHighligh_UnHover} onClick={HandleHighlight_Click}>{highlightText[i]}</span>);
        const lastHighlightTextIndex = firstHighlightTextIndex + highlightText[i].length;
        const numOfLettterAfter = i !== highlightText.length-1 ? text.indexOf(highlightText[+i+1]) : text.length;
        contentWithHighlight.push(text.substring(lastHighlightTextIndex, numOfLettterAfter));
      }
      setBulletContent(contentWithHighlight);
    }
    else {
      setBulletContent(text);
    }

  }, [text, highlightText, HandleHighlight_Hover, HandleHighligh_UnHover,HandleHighlight_Click])


  return (
    <BulletListingItem>
      <Bullet size={"5px"} letterSpacing={0.015}>
        <BulletListingText>{bulletContent}</BulletListingText>
      </Bullet>
    </BulletListingItem>
  )
}


const BulletListing = ({ bulletList, padding, rowGap }: BulletListingProps) => {
  const theme = useTheme();
  const modalContainerRef = useRef<null | HTMLDivElement>(null);
  const mobileModalContainerRef = useRef<any>(null);

  const [currentTooltipContent, setCurrentTooltipContent] = useState(null)

  const displayModal = (content: number, xCoord: number, yCoord: number, type: string) => {
    // document.body.style.overflowY = "hidden";

    if (type === "click") {
      if (mobileModalContainerRef && mobileModalContainerRef.current) {
        mobileModalContainerRef.current.open();
      }
    }
    else {
      let childrens = modalContainerRef.current?.children as HTMLCollectionOf<HTMLElement>;
      if (childrens.length > 0) {
        childrens[0].style.opacity = "1";
        childrens[0].style.left = (xCoord - 70).toString() + "px";
        childrens[0].style.top = yCoord.toString() + "px";
      }
      if (modalContainerRef && modalContainerRef.current) {
        modalContainerRef.current.style.opacity = "1";
      }
    }


  }


  const hideModal = (type: string) => {
    
    document.body.style.overflowY = "unset";
    if(type==="click") {
      if (mobileModalContainerRef && mobileModalContainerRef.current) {
        console.log("CLOSE EXIST");
        mobileModalContainerRef.current.close();
      }
    }
    else {
      if (modalContainerRef && modalContainerRef.current) {
        modalContainerRef.current.style.opacity = "0";
      }
  
      let childrens = modalContainerRef.current?.children as HTMLCollectionOf<HTMLElement>;
      if (childrens.length > 0) {
        childrens[0].style.opacity = "0";
      }
    }

  }

  const showTooltip = (tooltipContent: any,e: any, type:string = "") => {
    setCurrentTooltipContent(tooltipContent);
    const targetClientRect = e.target.getBoundingClientRect();
    displayModal(1,targetClientRect.left + 56,targetClientRect.top + targetClientRect.height - 5,type);
  }

  const hideTooltip = (e: any) => {
    hideModal("");
  }
  
  return (
    <React.Fragment>

      <BulletLisingContainer padding={padding} rowGap={rowGap}>
        {bulletList.map((bulletItem) => (
          <BulletItem key={bulletItem.text}
            {...bulletItem}
            onHighlightHover={showTooltip}
            onHighlightUnHover={hideTooltip}
            onHighlightClick={showTooltip}
          />
        ))}

        <ModalContainer className="ModalContainer" ref={modalContainerRef}>
          <div style={{ opacity: 0, position: 'absolute' }}>
            <Tooltip maxWidth={200} theme={theme}>
              {currentTooltipContent!}
            </Tooltip>
          </div>
        </ModalContainer>
      </BulletLisingContainer>

      <MobileModalContainer>
        <BottomSheetDrag ref={mobileModalContainerRef}>
          <TooltipBottomSheet theme={themeDefault}>
            <div>
              {currentTooltipContent!}
            </div>
          </TooltipBottomSheet>
        </BottomSheetDrag>
      </MobileModalContainer>
    </React.Fragment>
  );
};

export { BulletListing };
